import * as types from './types';
import { setGroupMessagesWithResponseMessage, updateTabSelected } from './utils';

const initialState = {
  messages: [],
  groupMessages: [],
  filesToUpload: [],
  loading: '',
  fileLoading: '',
  snackBarAdjuntos: {},
  showModal: false,
  leadName: '',
  tabs: [
    { key: 'messages', isSelected: true },
    { key: 'notes', isSelected: false }
  ],
  quicklyResponse: [{ key: 'option1' }, { key: 'option2' }, { key: 'option3' }],
  disabledButton: true
};

const MessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_MESSAGES:
      state.loading = 'loading';
      state.groupMessages = [];
      state.messages = [];
      state.showModal = false;
      state.filesToUpload = [];
      return { ...state };
    case types.FETCH_MESSAGES_SUCCEEDED:
      state.loading = 'loaded';
      state.groupMessages = action.payload.groupMessages;
      state.messages = action.payload.messages;
      return { ...state };
    case types.FETCH_MESSAGES_FAILED:
      state.loading = 'error';
      return { ...state };
    case types.CHANGE_TAB_OPTION:
      state.tabs = updateTabSelected(action.payload)(state.tabs);
      return { ...state };
    case types.ADD_MESSAGE:
      state.messages.push(action.payload);
      setGroupMessagesWithResponseMessage(state.messages)(groupMessages => {
        state.groupMessages = groupMessages;
      });
      return { ...state };
    case types.ADD_MESSAGE_SUCCEEDED:
      state.messages.map(m => {
        if (m.message_id === action.payload.message_id) {
          m.request = false;
        }
        return m;
      });
      setGroupMessagesWithResponseMessage(state.messages)(groupMessages => {
        state.groupMessages = groupMessages;
      });
      return { ...state };
    case types.SET_TRANSLATION:
      state.quicklyResponse = action.payload;
      return { ...state };

    case types.ADD_FILE_SUCCEEDED:
      state.filesToUpload.push(action.payload[0]);
      state.fileLoading = '';
      state.showModal = false;
      return { ...state };

    case types.ADD_FILE:
      state.fileLoading = 'loading';
      return { ...state };

    case types.REMOVE_FILE:
      state.filesToUpload.splice(action.payload, 1);
      return { ...state };

    case types.RESET_FILES:
      return {
        ...state,
        filesToUpload: []
      };

    case types.ERROR_UPLOAD:
      state.fileLoading = 'error';
      return { ...state };

    case types.REVERT_ERROR:
      state.fileLoading = '';
      return { ...state };

    case types.SHOW_SNACKBAR:
      return {
        ...state,
        snackBarAdjuntos: action.payload
      };
    case types.HIDE_SNACKBAR:
      return {
        ...state,
        snackBarAdjuntos: { ...state.snackBarAdjuntos, show: false }
      };

    case types.SHOW_MODAL:
      return {
        ...state,
        showModal: true
      };

    default:
      return { ...state };
  }
};

export default MessageReducer;
